import { render, staticRenderFns } from "./vendorAssociatedClinicList.vue?vue&type=template&id=b4d06958&"
import script from "./vendorAssociatedClinicList.vue?vue&type=script&lang=js&"
export * from "./vendorAssociatedClinicList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports